import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import vehicleManagementServices from '@src/services/vehicleManagement/vehicleManagement.services';

export const getVehicleList = createAsyncThunk(
  'getVehicleList',
  async (body, { getState, rejectWithValue }) => {
    try {
      const customer = await getState().customer;
      const customerId = body?.customerId ?? customer?.selectedCustomer?.customerId;
      let req = body?.data;
      if (req && !req.customerId) {
        req.customerId = customerId;
      }
      const { data } = await vehicleManagementServices.getVehicleList({
        data: req ?? { customerId },
      });
      return data;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const downloadActivationCodeForBP = createAsyncThunk(
  'downloadActivationCodeForBP',
  async (body, { getState, rejectWithValue }) => {
    try {
      const customer = await getState().customer;
      const customerId = body?.customerId ?? customer?.selectedCustomer?.customerId;
      const { data } = await vehicleManagementServices.downloadActivationCodeForBP({
        data: { customerId },
      });
      return data;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const getUpdateVehicleLimitsList = createAsyncThunk(
  'getUpdateVehicleLimitsList',
  async ({ request }, { getState, rejectWithValue }) => {
    try {
      const response = await vehicleManagementServices.getUpdateVehicleLimitsList({
        request,
      });
      return response;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const getUpdateVehiclesUsableDays = createAsyncThunk(
  'getUpdateVehiclesUsableDays',
  async ({ request }, { getState, rejectWithValue }) => {
    try {
      const response = await vehicleManagementServices.getUpdateVehiclesUsableDays({
        request,
      });
      return response;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const removeLimitRestriction = createAsyncThunk(
  'removeLimitRestriction',
  async ({ request }, { getState, rejectWithValue }) => {
    try {
      const response = await vehicleManagementServices.removeLimitRestriction({
        request,
      });
      return response;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const getUpdateVehicleDisable = createAsyncThunk(
  'getUpdateVehicleDisable',
  async ({ request }, { getState, rejectWithValue }) => {
    try {
      const response = await vehicleManagementServices.getUpdateVehicleDisable({
        request,
      });
      return response;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const deletePlateAllDevices = createAsyncThunk(
  'deletePlateAllDevices',
  async ({ request }, { getState, rejectWithValue }) => {
    try {
      const response = await vehicleManagementServices.deletePlateAllDevices({
        request,
      });
      return response;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const createVehicleDepartments = createAsyncThunk(
  'createVehicleDepartments',
  async ({ department }, { getState, rejectWithValue }) => {
    try {
      const customerId = await getState()?.customer?.selectedCustomer?.customerId;
      let request = { ...department };
      if (!request.customerId) {
        request.customerId = customerId;
      }
      const data = await vehicleManagementServices.createVehicleDepartments({ request });
      return data;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const updateVehicleDepartments = createAsyncThunk(
  'updateVehicleDepartments',
  async ({ department }, { getState, rejectWithValue }) => {
    try {
      const customerId = await getState()?.customer?.selectedCustomer?.customerId;
      let request = { ...department };
      if (!request.customerId) {
        request.customerId = customerId;
      }
      const data = await vehicleManagementServices.updateVehicleDepartments({ request });
      return data;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const deleteVehicleDepartments = createAsyncThunk(
  'deleteVehicleDepartments',
  async ({ department }, { rejectWithValue }) => {
    try {
      const data = await vehicleManagementServices.deleteVehicleDepartments({ department });
      return data;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const updateActivationCodeForBP = createAsyncThunk(
  'updateActivationCodeForBP',
  async (body, { getState, rejectWithValue }) => {
    try {
      const customerId = await getState()?.customer?.selectedCustomer?.customerId;
      let request = { ...body };
      if (!request.customerId) {
        request.customerId = customerId;
      }
      const data = await vehicleManagementServices.updateActivationCodeForBP({ request });
      return data;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

const initialState = {
  vehicleList: [],
  customVehicleList: [],
  isSelectCheckAll: false,
  selectedRowKeys: [],
  selectedRowVehicleIds: [],
  activeVehicles: 0,
  passiveVehicles: 0,
  vehicleLimit: 0,
  vehicleAvailableLimit: 0,
  externalId: '',
  providerList: null,
  statusList: null,
  deviceList: null,
  limitTypeList: null,
  limitValueTypeList: null,
  plateList: [],
  driverNameSurnameList: [],
  loading: {
    vehicleList: false,
    vehicleLimitsList: false,
    vehiclesUsableDays: false,
  },
  IsBpCustomer: 0,
};

export const vehicleManagementSlice = createSlice({
  name: 'vehicleManagement',
  initialState,
  reducers: {
    resetCurrentLoadVehicleManagement: (state) => {
      return initialState;
    },
    setSelectedRowKeys: (state, action) => {
      state.selectedRowKeys = action.payload;
    },
    setSelectedRowVehicleIds: (state, action) => {
      state.selectedRowVehicleIds = action.payload;
    },
    setIsSelectCheckAll: (state, action) => {
      state.isSelectCheckAll = action.payload;
    },
    resetSelectedRowKeys: (state) => {
      state.selectedRowKeys = [];
      state.isSelectCheckAll = false;
    },
    resetSelectedRowVehicleIds: (state) => {
      state.selectedRowVehicleIds = [];
      state.isSelectCheckAll = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getVehicleList.pending, (state) => {
        state.loading.vehicleList = true;
      })
      .addCase(getUpdateVehicleLimitsList.pending, (state) => {
        state.loading.vehicleLimitsList = true;
      })
      .addCase(getUpdateVehiclesUsableDays.pending, (state) => {
        state.loading.vehiclesUsableDays = true;
      })
      .addCase(getVehicleList.fulfilled, (state, action) => {
        state.loading.vehicleList = false;
        state.vehicleList = action?.payload?.vehicles || [];
        state.providerList = action?.payload?.providerList || [];
        state.statusList = action?.payload?.statusList || [];
        state.deviceList = action?.payload?.deviceList || [];
        state.limitTypeList = action?.payload?.limitTypeList || [];
        state.limitValueTypeList = action?.payload?.limitValueTypeList || [];
        state.plateList = action?.payload?.plateList || [];
        state.driverNameSurnameList = action?.payload?.driverNameSurnameList || [];
        state.activeVehicles = action.payload?.activeVehicles || 0;
        state.passiveVehicles = action.payload?.passiveVehicles || 0;
        state.vehicleLimit = action.payload?.limit || 0;
        state.vehicleAvailableLimit = action.payload?.availableLimit || 0;
        state.externalId = action.payload?.externalId || 0;
        state.IsBpCustomer = action.payload?.isBpCustomer || 0;
        state.customVehicleList = action?.payload?.vehicles || [];
        let cArr = [];
        try {
          const vList = action?.payload?.vehicles || [];
          if (vList?.length > 0) {
            vList.map((item) => {
              if (cArr.length === 0) {
                cArr.push(item);
              } else {
                let findIndex = -1;
                findIndex = cArr.findIndex((cItem) => cItem.plate === item.plate);
                if (
                  findIndex !== -1 &&
                  item.deviceTypeId === 18 &&
                  cArr[findIndex].deviceTypeId === 2
                ) {
                  cArr[ringIndex] = item;
                } else if (
                  findIndex !== -1 &&
                  item.deviceTypeId === 2 &&
                  cArr[findIndex].deviceTypeId === 18
                ) {
                } else {
                  cArr.push(item);
                }
              }
            });
          }
          state.customVehicleList = cArr;
        } catch (error) {
          console.error('error', error);
        }
        try {
          const vList = cArr || action?.payload?.vehicles;
          let mArr = [];
          if (vList?.length > 0) {
            vList.map((item) => {
              if (mArr.length === 0) {
                mArr.push(item);
              } else {
                let findIndex = -1;
                findIndex = mArr.findIndex((cItem) => cItem.plate === item.plate);
                if (findIndex !== -1) {
                  if (!mArr[findIndex].multipleDevice) {
                    mArr[findIndex].multipleDevice = [];
                  }
                  if (mArr[findIndex].statusLabel === 'Pasif' && item.statusLabel === 'Aktif') {
                    const temp = mArr[findIndex];
                    mArr[findIndex] = item;
                    mArr[findIndex].multipleDevice = temp.multipleDevice;
                    temp.multipleDevice = null;
                    mArr[findIndex].multipleDevice.push(temp);
                  } else {
                    mArr[findIndex].multipleDevice.push(item);
                  }
                } else {
                  mArr.push(item);
                }
              }
            });
          }
          state.customVehicleList = mArr;
        } catch (error) {
          console.error('error', error);
        }
      })
      .addCase(getUpdateVehicleLimitsList.fulfilled, (state, action) => {
        state.loading.vehicleLimitsList = false;
      })
      .addCase(getUpdateVehiclesUsableDays.fulfilled, (state, action) => {
        state.loading.vehiclesUsableDays = false;
      })
      .addCase(getUpdateVehicleLimitsList.rejected, (state, action) => {
        state.loading.vehicleLimitsList = false;
        state.error = action.payload || 'Error';
      })
      .addCase(getUpdateVehiclesUsableDays.rejected, (state, action) => {
        state.loading.vehiclesUsableDays = false;
        state.error = action.payload || 'Error';
      })
      .addCase(getVehicleList.rejected, (state, action) => {
        state.loading.vehicleList = false;
        state.vehicleList = [];
        state.customVehicleList = [];
        state.providerList = [];
        state.statusList = [];
        state.deviceList = [];
        state.limitTypeList = [];
        state.limitValueTypeList = [];
        state.plateList = [];
        state.driverNameSurnameList = [];
        state.activeVehicles = 0;
        state.passiveVehicles = 0;
        state.error = action.payload || 'Error';
        state.IsBpCustomer = 0;
      });
  },
});

export const {
  resetCurrentLoadVehicleManagement,
  setSelectedRowKeys,
  resetSelectedRowKeys,
  setSelectedRowVehicleIds,
  resetSelectedRowVehicleIds,
  setIsSelectCheckAll,
} = vehicleManagementSlice.actions;
